<mat-toolbar class="lsa-navigation-bar">
  @if (!shouldHide()) {
    <a
      [style.color]="textColorVar()"
      [style.text-shadow]="useShadowValue()"
      [routerLink]="homeLink"
      class="title"
      (click)="setActiveOption()"
      >{{ title }}</a
    >
    @for (option of options; track option) {
      @if (option.options) {
        <mat-menu
          [class]="backgroundClass()"
          #menu="matMenu"
          (closed)="setActiveOption()"
        >
          @for (menuOption of option.options; track menuOption) {
            <a
              [style.color]="textColorVar()"
              [style.text-shadow]="useShadowValue()"
              mat-menu-item
              [routerLink]="menuOption.link"
              class="menu-item"
              >{{ menuOption.text }}</a
            >
          }
        </mat-menu>
        <a
          [style.color]="textColorVar()"
          [style.text-shadow]="useShadowValue()"
          [matMenuTriggerFor]="menu"
          class="option"
          [class.active]="
            activeOption() && activeOption()?.index === option.index
          "
          (click)="setActiveOption(option)"
        >
          {{ option.text }}
        </a>
      } @else {
        <a
          [style.color]="textColorVar()"
          [style.text-shadow]="useShadowValue()"
          [routerLink]="option.link"
          class="option"
          >{{ option.text }}</a
        >
      }
    }
    <span class="spacer"></span>
    @if (button) {
      <a [routerLink]="button.link" mat-flat-button class="donate-button">
        {{ button.text }}
      </a>
    }
  } @else {
    <span class="spacer"></span>
    <button
      mat-button
      class="nav-hamburger-button"
      (click)="toggleMobileMenu()"
    >
      <span>
        <mat-icon class="nav-hamburger-icon" [style.color]="textColorVar()"
          >drag_handle</mat-icon
        >
      </span>
    </button>
  }
</mat-toolbar>
